import React from "react";
import { v4 as uuid } from "uuid";

export default function AnchorSection({ selectedToken, anchors, setAnchors }) {
  const addAnchor = () => {
    if (!selectedToken) return;

    setAnchors([
      ...anchors,
      {
        id: uuid(),
        text: selectedToken.text,
        page: selectedToken.page
      }
    ]);
  };

  return (
    <section>
      <h4>Anchors</h4>

      <button onClick={addAnchor} disabled={!selectedToken}>
        ? Create Anchor
      </button>

      {anchors.map(a => (
        <div key={a.id} style={styles.item}>
          <b>{a.text}</b> (page {a.page})
        </div>
      ))}
    </section>
  );
}

const styles = {
  item: {
    fontSize: "12px",
    marginTop: "4px"
  }
};
